
  export default {
    name: `MyCheckDefaultResult`,
    props: {
      myCheck: {
        type: Object,
        default: undefined
      }
    }
  }
